import React from "react";

import { ScheduleContextProvider } from "../../hooks";
import { HubHookFormWrapper, PageContent } from "../../components";

import SchedulePageContent from "./SchedulePageContent";

export const SchedulePage = () => {
  return (
    <ScheduleContextProvider>
      <PageContent disablePadding>
        <HubHookFormWrapper onSubmit={() => {}} sx={{ height: "100%" }}>
          <SchedulePageContent />
        </HubHookFormWrapper>
      </PageContent>
    </ScheduleContextProvider>
  );
};

export default SchedulePage;
